import Chart from 'react-apexcharts';
import { Grid, Skeleton, Tab, Tabs } from '@mui/material'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGetTrackStatsQuery } from '../../../api/trackApiSlice'
import moment from 'moment';


const TrackStats = () => {
    let { id } = useParams()
    const [style, setStyle] = useState('Général')

    const {
        data: trackStats,
        isFetchingStats
    } = useGetTrackStatsQuery(id)

    const handleChangeStyle = (event, newValue) => {
        // console.log(newValue)
        setStyle(newValue)
    }

    const statsByStyle = useMemo(() => {
        if (!trackStats || !trackStats[0].stats)
            return []

        var styles = [...new Set(trackStats[0].stats.map( stat => stat.style ))]
        var countries = [...new Set(trackStats[0].stats.map( stat => stat.country ))]

        setStyle(styles[0])

        return styles.map( (style, i) => {
            return { style: style, statsByCountry: countries.map( (country, y) => { 
                if (trackStats[0].stats.filter( stat => stat.style === style && stat.country === country).length > 0)
                return {
                country: country, 
                stats: trackStats[0].stats.filter( stat => stat.style === style && stat.country === country)    
            }
            else return []
        } ).filter(o => o) }
        })
    }, [trackStats])


    return trackStats && statsByStyle && !isFetchingStats
    ?   <Grid size={12} sx={{overflow: 'hidden', height: '100%', width: '100%'}}>
            <Tabs textColor='secondary' indicatorColor='secondary' value={style} onChange={handleChangeStyle} aria-label="style tabs">
            { statsByStyle.map( (sStyle, i) => <Tab key={i} value={sStyle.style} label={sStyle.style} sx={{color: 'white!important'}} />) }
            </Tabs>
        {
            statsByStyle.filter(statByStyle => statByStyle.style === style).map((statByStyle, i) => 
            <Chart options={{
                grid: {
                    show: false
                },
                stroke: {
                    curve: 'smooth',
                },
                markers: {
                    size: 1,
                },
                theme: {
                    mode: 'dark', 
                    monochrome: {
                        enabled: true,
                        color: '#08088A',
                        shadeTo: 'light',
                        shadeIntensity: 0.65
                    }
                },
                chart: {
                    id: 'apexchart-example',
                    foreColor: '#FFFFFF',
                    background: '#ffffff00',
                    toolbar: {
                        show: false,
                    },
                    animations: {
                        enabled: false,
                    }
                },
                yaxis: {
                    min: 1,
                    max: 200,//Math.min(200, Math.max(...statByStyle.statsByCountry.filter(stat => stat.stats != null ).map(stat => stat.stats).flat().map(stat => stat.position))),
                    reversed: true,
                    position: 'right',
                    tickAmount: 20,
                    labels: {
                        formatter: function(val, index) {
                            return val.toFixed(0)
                        }
                    }
                },
                xaxis: {
                    tickAmount: 10,
                    position: 'top',
                    categories: [...new Set(statByStyle.statsByCountry.filter(stat => stat.stats != null ).map(stat => stat.stats).flat().sort((a, b) => new Date(a.date) - new Date(b.date)).map( stat => moment(stat.date).format('DD/MM/YY') ))],
                },

                }} 
                series={statByStyle.statsByCountry.map( countryStats => {
                    return countryStats && countryStats.stats && countryStats.stats.length > 0 
                    ? {
                        name: countryStats.country,
                        data: countryStats.stats.map( stat => stat.position )
                    }
                    : []
                }).filter(a => a)}
                key={i}
                type="line" 
                width={'100%'} 
                height={'85%'} />
            ) 
        }
        </Grid>
    : 
        <Skeleton variant="rectangular" width={'100%'} height={'100%'} sx={{backgroundColor: '#00000060',}}/>
}

export default TrackStats
